import { Modal } from "./AdministrationFields";
import { emptyStyle, primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import { inputStyle, reportEditRowStyle } from "../styles/administrationStyles";

export function AdministrationReportModal({ rows, ehpadName, loading, onChangeRow, onDownload, onClose }) {
    const includedCount = rows.filter(row => row.included).length;
    return (
        <Modal title="Préparer le rapport administratif" onClose={onClose} width={900}>
            <div style={{ display: "grid", gap: "14px" }}>
                <p style={{ margin: 0, color: "#475569", lineHeight: 1.5 }}>
                    Vérifiez les demandes avant génération du PDF pour {ehpadName || "l'EHPAD"}.
                </p>
                {loading ? (
                    <p style={emptyStyle}>Chargement du rapport...</p>
                ) : rows.length === 0 ? (
                    <p style={emptyStyle}>Aucune demande à transmettre.</p>
                ) : (
                    <div style={{ display: "grid", gap: "10px", maxHeight: "58vh", overflowY: "auto" }}>
                        {rows.map(row => (
                            <div key={row.key} style={reportEditRowStyle}>
                                <label style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: 800, color: "#1e293b" }}>
                                    <input
                                        type="checkbox"
                                        checked={row.included}
                                        onChange={event => onChangeRow(row.key, { included: event.target.checked })}
                                    />
                                    {row.patientName}
                                </label>
                                <textarea
                                    aria-label={`Demande ${row.patientName}`}
                                    rows={2}
                                    style={{ ...inputStyle, resize: "vertical" }}
                                    value={row.message}
                                    onChange={event => onChangeRow(row.key, { message: event.target.value })}
                                />
                            </div>
                        ))}
                    </div>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                    <button type="button" onClick={onClose} style={secondaryButtonStyle}>Annuler</button>
                    <button type="button" disabled={loading || includedCount === 0} onClick={onDownload} style={primaryButtonStyle}>
                        Télécharger le PDF
                    </button>
                </div>
            </div>
        </Modal>
    );
}
